import { render } from "./OperatingSystemDetails.vue?vue&type=template&id=012c1f0b&scoped=true"
import script from "./OperatingSystemDetails.vue?vue&type=script&lang=js"
export * from "./OperatingSystemDetails.vue?vue&type=script&lang=js"

import "./OperatingSystemDetails.vue?vue&type=style&index=0&id=012c1f0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012c1f0b"]])

export default __exports__